const BURMESE_NUMERALS = ['၀', '၁', '၂', '၃', '၄', '၅', '၆', '၇', '၈', '၉'];
const BURMESE_MONTHS = [
  'ဇန်နဝါရီ', 'ဖေဖော်ဝါရီ', 'မတ်', 'ဧပြီ', 'မေ', 'ဇွန်',
  'ဇူလိုင်', 'ဩဂုတ်', 'စက်တင်ဘာ', 'အောက်တိုဘာ', 'နိုဝင်ဘာ', 'ဒီဇင်ဘာ'
];

function formatDate(dateString, lng = 'en', timeZone = 'Asia/Yangon') {
  if (!dateString) return "N/A";

  try {
    // Ensure consistent UTC parsing
    const date = new Date(dateString);

    if (isNaN(date)) return "Invalid Date";

    if (lng === 'mm') {
      // Myanmar format without time zone shift
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${convertToBurmeseNumerals(day, lng)} ${BURMESE_MONTHS[month - 1]} ${convertToBurmeseNumerals(year, lng)}`;
    }

    // English format with correct UTC handling
    return date.toLocaleDateString('en-GB', {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      timeZone
    });
  } catch (e) {
    console.error("Date formatting error:", e);
    return "N/A";
  }
}

/**
 * Gets localized month name
 * @param {number} month - Month number (1-12)
 * @param {'en'|'mm'} [lng='en'] - Language code
 * @returns {string} Month name
 */
function getMonthName(month, lng = 'en') {
  if (month < 1 || month > 12) return 'Invalid month';
  
  if (lng === 'mm') {
    return BURMESE_MONTHS[month - 1];
  }
  
  return new Date(2023, month - 1).toLocaleString(lng, { month: 'long' });
}

/**
 * Formats year and month display
 * @param {number} year - Full year (e.g., 2023)
 * @param {number} month - Month number (1-12)
 * @param {'en'|'mm'} [lng='en'] - Language code
 * @returns {string} Formatted date string
 */
function formatDateDisplay(year, month, lng = 'en') {
  if (lng === 'mm') {
    return `${BURMESE_MONTHS[month - 1]}လ ${convertToBurmeseNumerals(year, lng)}`;
  }

  return `${new Date(year, month - 1).toLocaleString(lng, { month: 'long' })} ${year}`;
}

/**
 * Converts numbers to Burmese numerals
 * @param {number|string} num - Number to convert
 * @returns {string} Burmese numeral string
 */
function convertToBurmeseNumerals(num, lng = 'en') {
  // Handle all falsy values except 0 and boolean false
  if ((num === null || num === undefined || num === '') && num !== 0 && num !== false) {
    return '';
  }

  try {
    const numberStr = num.toString();
    
    if (lng !== 'mm') {
      return numberStr; // Return original for non-Burmese
    }

    return numberStr.replace(/[0-9]/g, d => {
      const digit = parseInt(d);
      return (digit >= 0 && digit <= 9) ? BURMESE_NUMERALS[digit] : d;
    });
    
  } catch (error) {
    console.error('Number conversion error:', error);
    return num?.toString() || '';
  }
}

function timeAgo(date, lng = 'en') {
  const now = new Date();
  
  // Normalize to midnight for day comparison
  const nowMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const dateMidnight = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  
  const diffInDays = Math.round((nowMidnight - dateMidnight) / (1000 * 60 * 60 * 24));

  if (lng === 'mm') {
    if (diffInDays >= 1) {
      const burmeseDays = convertToBurmeseNumerals(diffInDays, lng);
      return `${burmeseDays} ရက်အကြာ`;
    }
    return "အခု";
  }

  // English
  if (diffInDays >= 1) {
    return `${diffInDays} day${diffInDays === 1 ? "" : "s"} ago`;
  }
  return "Just now";
}

// Create named object containing all functions
const dateUtils = {
  formatDate,
  getMonthName,
  formatDateDisplay,
  convertToBurmeseNumerals,
  timeAgo,
};

// Export the object as default
export default dateUtils;
  